'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _tcombValidation = require('tcomb-validation');

var _tcombValidation2 = _interopRequireDefault(_tcombValidation);

var Size = _tcombValidation2['default'].enums.of('xs sm md lg', 'Size');

exports['default'] = Size;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form/lib/templates/bootstrap/Size.js
// module id = 223
// module chunks = 0 1 2